import { Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Issue } from '../../IssueTrackerContext/types'
import { useIssueTrackerContext } from '../../IssueTrackerContext'
import EditModalBody from './components/EditModalBody'
import { EditModalBodyValues } from './components/EditModalBody/types'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { useIssueReportsSelectOptionsContext } from '../../../../IssueReportsSelectOptionsContext'

export function useEdit(): EditRowActionOptions<Issue, EditModalBodyValues> {
  const { edit } = useIssueTrackerContext()
  const { toCustomFieldEditorValue, toMutateCustomFieldsInput } =
    useProjectCustomFieldsContext()
  const { toLabeledValues: toPayItems, fromLabeledValues: fromPayItems } =
    usePayItemSelectContext()
  const { toLabeledValues: toReports, fromLabeledValues: fromReports } =
    useIssueReportsSelectOptionsContext()
  return {
    permission: [Permission.EditIssue, Permission.EditIssueResponse],
    modal: {
      type: 'simple',
      recordName: 'formattedNumber',
      initialValues: ({
        description,
        customFields,
        externalLinks,
        types,
        payItems,
        reports,
        response,
      }) => ({
        customFields: toCustomFieldEditorValue(customFields),
        externalLinks: externalLinks.map(({ href, label }) => ({
          label,
          href,
        })),
        types: toLabeledValues(types, {
          value: 'id',
          label: 'name',
          tooltip: 'description',
        }),
        payItems: toPayItems(payItems),
        description,
        response,
        reports: toReports(
          reports.map(
            ({
              asphaltLot,
              concreteTest,
              concreteTestSet,
              dailyInspectionControlPoint,
              dailyInspectionInspection,
              dailyInspectionPunchList,
              lot,
            }) =>
              asphaltLot ??
              concreteTest ??
              concreteTestSet ??
              dailyInspectionControlPoint ??
              dailyInspectionInspection ??
              dailyInspectionPunchList ??
              lot
          )
        ),
      }),
      body: (issue) => <EditModalBody {...issue} />,
      onOk: async (
        { id },
        {
          customFields,
          description,
          externalLinks,
          payItems,
          reports,
          response,
          types,
        }
      ) =>
        edit({
          id,
          customFields: toMutateCustomFieldsInput(customFields),
          description,
          externalLinks,
          payItemIds: fromPayItems(payItems),
          reports: fromReports(reports),
          response,
          typeIds: types?.map(({ value }) => value as string),
        }),
    },
  }
}
